"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _common = require("@webex/common");
var _internalMediaCore = require("@webex/internal-media-core");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _constants = require("../constants");
/**
 * @class MediaConnectionAwaiter
 */
var MediaConnectionAwaiter = exports.default = /*#__PURE__*/function () {
  /**
   * @param {MediaConnectionAwaiterProps} mediaConnectionAwaiterProps
   */
  function MediaConnectionAwaiter(_ref) {
    var webrtcMediaConnection = _ref.webrtcMediaConnection;
    (0, _classCallCheck2.default)(this, MediaConnectionAwaiter);
    (0, _defineProperty2.default)(this, "webrtcMediaConnection", void 0);
    (0, _defineProperty2.default)(this, "timer", void 0);
    (0, _defineProperty2.default)(this, "defer", void 0);
    (0, _defineProperty2.default)(this, "retried", void 0);
    (0, _defineProperty2.default)(this, "iceConnected", void 0);
    (0, _defineProperty2.default)(this, "onTimeoutCallback", void 0);
    (0, _defineProperty2.default)(this, "peerConnectionStateCallback", void 0);
    (0, _defineProperty2.default)(this, "iceConnectionStateCallback", void 0);
    (0, _defineProperty2.default)(this, "iceGatheringStateCallback", void 0);
    this.webrtcMediaConnection = webrtcMediaConnection;
    this.defer = new _common.Defer();
    this.retried = false;
    this.iceConnected = false;
    this.onTimeoutCallback = this.onTimeout.bind(this);
    this.peerConnectionStateCallback = this.peerConnectionStateHandler.bind(this);
    this.iceConnectionStateCallback = this.iceConnectionStateHandler.bind(this);
    this.iceGatheringStateCallback = this.iceGatheringStateHandler.bind(this);
  }

  /**
   * Returns true if the connection is connected, false otherwise.
   *
   * @returns {boolean}
   */
  (0, _createClass2.default)(MediaConnectionAwaiter, [{
    key: "isConnected",
    value: function isConnected() {
      return this.webrtcMediaConnection.getConnectionState() === _internalMediaCore.ConnectionState.Connected;
    }

    /**
     * Returns true if the connection is in an unrecoverable "failed" state
     *
     * @returns {boolean}
     */
  }, {
    key: "isFailed",
    value: function isFailed() {
      return this.webrtcMediaConnection.getConnectionState() === _internalMediaCore.ConnectionState.Failed;
    }

    /**
     * Returns true if the ICE Gathering is completed, false otherwise.
     *
     * @returns {boolean}
     */
  }, {
    key: "isIceGatheringCompleted",
    value: function isIceGatheringCompleted() {
      return this.webrtcMediaConnection.getIceGatheringState() === 'complete';
    }

    /**
     * Clears the callbacks.
     *
     * @returns {void}
     */
  }, {
    key: "clearCallbacks",
    value: function clearCallbacks() {
      this.webrtcMediaConnection.off(_internalMediaCore.MediaConnectionEventNames.ICE_GATHERING_STATE_CHANGED, this.iceGatheringStateCallback);
      this.webrtcMediaConnection.off(_internalMediaCore.MediaConnectionEventNames.PEER_CONNECTION_STATE_CHANGED, this.peerConnectionStateCallback);
      this.webrtcMediaConnection.off(_internalMediaCore.MediaConnectionEventNames.ICE_CONNECTION_STATE_CHANGED, this.iceConnectionStateCallback);
    }

    /**
     * On connection state change.
     *
     * @returns {void}
     */
  }, {
    key: "connectionStateChange",
    value: function connectionStateChange() {
      _loggerProxy.default.logger.log("Media:MediaConnectionAwaiter#connectionStateChange --> connection state: ".concat(this.webrtcMediaConnection.getConnectionState()));
      if (this.isFailed()) {
        _loggerProxy.default.logger.warn('Media:MediaConnectionAwaiter#connectionStateChange --> ICE failed, rejecting');
        this.clearCallbacks();
        this.defer.reject({
          iceConnected: this.iceConnected
        });
      }
      if (!this.isConnected()) {
        return;
      }
      clearTimeout(this.timer);
      this.clearCallbacks();
      this.defer.resolve();
    }

    /**
     * Listener for peer connection state change.
     *
     * @returns {void}
     */
  }, {
    key: "peerConnectionStateHandler",
    value: function peerConnectionStateHandler() {
      var peerConnectionState = this.webrtcMediaConnection.getPeerConnectionState();
      _loggerProxy.default.logger.log("Media:MediaConnectionAwaiter#peerConnectionStateHandler --> Peer connection state change -> ".concat(peerConnectionState));
      this.connectionStateChange();
    }

    /**
     * Listener for ICE connection state change.
     *
     * @returns {void}
     */
  }, {
    key: "iceConnectionStateHandler",
    value: function iceConnectionStateHandler() {
      var iceConnectionState = this.webrtcMediaConnection.getIceConnectionState();
      _loggerProxy.default.logger.log("Media:MediaConnectionAwaiter#iceConnectionStateHandler --> ICE connection state change -> ".concat(iceConnectionState));
      if (iceConnectionState === 'connected' && !this.iceConnected) {
        this.iceConnected = true;
      }
      this.connectionStateChange();
    }

    /**
     * Listener for ICE gathering state change.
     *
     * @returns {void}
     */
  }, {
    key: "iceGatheringStateHandler",
    value: function iceGatheringStateHandler() {
      var iceGatheringState = this.webrtcMediaConnection.getIceGatheringState();
      _loggerProxy.default.logger.log("Media:MediaConnectionAwaiter#iceGatheringStateHandler --> ICE gathering state change -> ".concat(iceGatheringState));
      if (!this.isIceGatheringCompleted()) {
        return;
      }
      if (this.isConnected()) {
        return;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(this.onTimeoutCallback, _constants.ICE_AND_DTLS_CONNECTION_TIMEOUT);
    }

    /**
     * Function called when the timeout is reached.
     *
     * @returns {void}
     */
  }, {
    key: "onTimeout",
    value: function onTimeout() {
      if (this.isConnected()) {
        this.clearCallbacks();
        this.defer.resolve();
        return;
      }
      if (!this.isIceGatheringCompleted()) {
        if (!this.retried) {
          _loggerProxy.default.logger.warn('Media:MediaConnectionAwaiter#onTimeout --> ICE gathering did not complete within the timeout for the first time, retrying once');

          // retry once if ICE gathering is not completed
          this.retried = true;
          clearTimeout(this.timer);
          this.timer = setTimeout(this.onTimeoutCallback, _constants.ICE_AND_DTLS_CONNECTION_TIMEOUT);
          return;
        }
        _loggerProxy.default.logger.warn('Media:MediaConnectionAwaiter#onTimeout --> ICE gathering did not complete within the timeout for the second time, rejecting');
      } else {
        _loggerProxy.default.logger.warn('Media:MediaConnectionAwaiter#onTimeout --> ICE gathering completed, but connection state is not connected, rejecting');
      }
      this.clearCallbacks();
      this.defer.reject({
        iceConnected: this.iceConnected
      });
    }

    /**
     * Waits for the webrtc media connection to be connected.
     *
     * @returns {Promise}
     */
  }, {
    key: "waitForMediaConnectionConnected",
    value: function waitForMediaConnectionConnected() {
      if (this.isConnected()) {
        return _promise.default.resolve();
      }
      this.webrtcMediaConnection.on(_internalMediaCore.MediaConnectionEventNames.PEER_CONNECTION_STATE_CHANGED, this.peerConnectionStateCallback);
      this.webrtcMediaConnection.on(_internalMediaCore.MediaConnectionEventNames.ICE_CONNECTION_STATE_CHANGED, this.iceConnectionStateCallback);
      this.webrtcMediaConnection.on(_internalMediaCore.MediaConnectionEventNames.ICE_GATHERING_STATE_CHANGED, this.iceGatheringStateCallback);
      this.timer = setTimeout(this.onTimeoutCallback, _constants.ICE_AND_DTLS_CONNECTION_TIMEOUT);
      return this.defer.promise;
    }
  }]);
  return MediaConnectionAwaiter;
}();
//# sourceMappingURL=MediaConnectionAwaiter.js.map
